import { ToastAction } from 'components/ui/toast';

/** Toast action offered when a voice call ends without the user hanging up. */
export const renderVoiceCallReconnectAction = (label: string, onReconnect: () => void) => (
  <ToastAction altText={label} onClick={onReconnect}>
    {label}
  </ToastAction>
);
